import { Emitter, Event } from 'vscode/vscode/vs/base/common/event';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';

class EmbedderTerminalService {
    constructor() {
        this._onDidCreateTerminal = ( new Emitter());
        this.onDidCreateTerminal = Event.buffer(this._onDidCreateTerminal.event);
    }
    createTerminal(options) {
        const slc = {
            name: options.name,
            isFeatureTerminal: true,
            customPtyImplementation(terminalId, cols, rows) {
                return ( new EmbedderTerminalProcess(terminalId, options.pty));
            },
        };
        this._onDidCreateTerminal.fire(slc);
    }
}
class EmbedderTerminalProcess extends Disposable {
    constructor(id, pty) {
        super();
        this.id = id;
        this.shouldPersist = false;
        this._onProcessReady = this._register(( new Emitter()));
        this.onProcessReady = this._onProcessReady.event;
        this._onDidChangeProperty = this._register(( new Emitter()));
        this.onDidChangeProperty = this._onDidChangeProperty.event;
        this._onProcessExit = this._register(( new Emitter()));
        this.onProcessExit = this._onProcessExit.event;
        this._pty = pty;
        this.onProcessData = this._pty.onDidWrite;
        if (this._pty.onDidClose) {
            this._register(this._pty.onDidClose(e => this._onProcessExit.fire(e || undefined)));
        }
        if (this._pty.onDidChangeName) {
            this._register(this._pty.onDidChangeName(e => this._onDidChangeProperty.fire({
                type: "title" ,
                value: e
            })));
        }
    }
    async start() {
        this._onProcessReady.fire({ pid: -1, cwd: '', windowsPty: undefined });
        this._pty.open();
        return undefined;
    }
    shutdown() {
        this._pty.close();
    }
    input() {
    }
    async processBinary() {
    }
    resize() {
    }
    clearBuffer() {
    }
    acknowledgeDataEvent() {
    }
    async setUnicodeVersion() {
    }
    async getInitialCwd() {
        return '';
    }
    async getCwd() {
        return '';
    }
    refreshProperty(property) {
        throw ( new Error(
            `refreshProperty is not suppported in EmbedderTerminalProcess. property: ${property}`
        ));
    }
    updateProperty(property, value) {
        throw ( new Error(
            `updateProperty is not suppported in EmbedderTerminalProcess. property: ${property}, value: ${value}`
        ));
    }
}

export { EmbedderTerminalService };
